const text = {
  LocationTypetext: "Ill-defined hypodensities seen in right {2} lobes.",
  LocationTypetextleft: "Ill-defined hypodensities seen in left {2} lobes.",
  LocationTypetext1: "Ill-defined hypodensities in right {2} lobes",
  LocationTypetextleft1: "Ill-defined hypodensities in left {2} lobes"
};

export function generateCtHeadReport(frmData, currentUser) {
  let report = "";
  const impression = [];

  if (frmData.NameTextFR3 && frmData.IDTextFR3 && frmData.AgeTextFR3 && frmData.GenderTextFR3 && frmData.TestDateTextFR3 && frmData.ReportDateTextFR3) {
    report += `
      <pre><b><header><table>
        <tr>
          <td>Name: ${frmData.NameTextFR3}</td>
          <td>Patient ID: ${frmData.IDTextFR3}</td>
          <td>Age: ${frmData.AgeTextFR3}</td>
        </tr>
        <tr>
          <td>Gender: ${frmData.GenderTextFR3}</td>
          <td>Test date: ${frmData.TestDateTextFR3}</td>
          <td>Report date: ${frmData.ReportDateTextFR3}</td>
        </tr>
        <tr>
          <td>Referral Dr: ${frmData.ReferralDrTextFR3 || "N/A"}</td>
          <td colspan="2">Report time: ${frmData.ReporttimeTextFR3 || "N/A"}</td>
        </tr>
      </table></header></b></pre>
    `;
  }

  // Base normal/atrophy check
  if (!frmData.allNormal && !frmData.Atrophy && !frmData.ChronicIschemic && !frmData.Hemorrhage && !frmData.Infarct) {
    report += `<h5><center><strong><u>LOW DOSE CT REPORT - BRAIN (PLAIN)</u></strong></center></h5><h5><strong><u>OBSERVATIONS:</u></strong></h5>`;
  } else {
    report += `<h5><center><strong><u>LOW DOSE CT REPORT - BRAIN (PLAIN)</u></strong></center></h5><h5><strong><u>OBSERVATIONS:</u></strong></h5>`;
  }

  if (frmData.allNormal) {
    report += "<p>No evidence of contusion, edema or intracranial hemorrhage is visualized.<br><br>No evidence of fracture.<br><br>The gray white differentiation is maintained.<br><br>The cerebellum, brainstem and basal cisterns appear normal.<br><br>Cerebello pontine angles and internal auditory meatus appear normal.<br><br>Ventricular system and sulci are normal for the age.<br><br>The sella and parasellar regions are normal.<br><br>The basal ganglia, thalami and capsular tracts appear normal.<br><br>The bones of skull and pericranial soft tissue appear normal.<br><br>Visualized paranasal sinuses appear normal.<b></p>";
    impression.push("<p><b>• No evidence of intracranial hemorrhage or bony injury.<br><br>• No significant abnormality is visualized in the Brain.</b></p>");
  }

  if (frmData.Atrophy) {
    if (frmData.Atrophytype === "Age Related Cerebral Atrophy") {
      report += "<p><b>• Ventricular system, sulci and basal cisterns appear prominent.</b><br><br>• No evidence of contusion, edema or intracranial hemorrhage is visualized.<br><br>• No evidence of fracture.<br><br>• The gray white differentiation is maintained.<br><br>• The cerebellum and brainstem appear normal.<br><br>• Cerebello pontine angles and internal auditory meatus appear normal.<br><br>• The sella and parasellar regions are normal.<br><br>• The basal ganglia, thalami and capsular tracts appear normal.<br><br>• The bones of skull and pericranial soft tissue appear normal.<br><br>• Visualized paranasal sinuses appear normal.<b>";
      impression.push("<b>Age related cerebral atrophy. </b>");
    }
    if (frmData.Atrophytype === "Age Advanced Cerebral Atrophy") {
      report += "<p><b>• Ventricular system, sulci and basal cisterns appear prominent.</b><br><br>• No evidence of contusion, edema or intracranial hemorrhage is visualized.<br><br>• No evidence of fracture.<br><br>• The gray white differentiation is maintained.<br><br>• The cerebellum and brainstem appear normal.<br><br>• Cerebello pontine angles and internal auditory meatus appear normal.<br><br>• The sella and parasellar regions are normal.<br><br>• The basal ganglia, thalami and capsular tracts appear normal.<br><br>• The bones of skull and pericranial soft tissue appear normal.<br><br>• Visualized paranasal sinuses appear normal<b>";
      impression.push("<b>Age advanced cerebral atrophy. </b>");
    }
  }

  if (frmData.Hemorrhage) {
    if (frmData.IntraRight) {
      if (frmData.Chronicity && frmData.ChronType && frmData.RadioType==="Multiple") {
        report += "<br><br><b>Multiple " + frmData.ChronType + " intraparenchymal hemorrhage </b>";
        impression.push("<b>" + frmData.ChronType + " Multiple intraparenchymal hemorrhage </b>");
      } else if (frmData.Chronicity && frmData.ChronType) {
        report += "<br><br><b>" + frmData.ChronType + " intraparenchymal hemorrhage </b>";
        impression.push("<b>" + frmData.ChronType + " intraparenchymal hemorrhage </b>");
      } else {
        report += "<br><br><b>Intraparenchymal hemorrhage </b>";
        impression.push("<b>Intraparenchymal hemorrhage </b>");
      }

      if (frmData.RightIntraLocation) {
        let arr = [];
        if (frmData.RightIntraFrontal) arr.push("frontal");
        if (frmData.RightIntraTemporal) arr.push("temporal");
        if (frmData.RightIntraParietal) arr.push("parietal");
        if (frmData.RightIntraOccipital) arr.push("occipital");
        
        if (arr.length > 0) {
          report += "<b>seen in right " + arr.join("-") + " lobes </b>";
          impression.push("<b>in right " + arr.join("-") + " lobes </b>");
        }

        let arrBase = [];
        if (frmData.RightIntraBasalGanglia) arrBase.push("basal ganglia");
        if (frmData.RightIntraThalamus) arrBase.push("thalamus");
        if (frmData.RightIntraCerebellum) arrBase.push("cerebellum");
        if (frmData.RightIntraMedulla) arrBase.push("medulla");
        if (frmData.RightIntraMidBrain) arrBase.push("midbrain");
        if (frmData.RightIntraPons) arrBase.push("pons");

        if (arrBase.length > 0) {
          report += "<b> and " + arrBase.join("-") + " region </b>";
          impression.push("<b> and " + arrBase.join("-") + " region </b>");
        }
      }

      if (frmData.Size) report += "<b>measuring " + frmData.SizeCCText + "x" + frmData.SizeAPText + "x" + frmData.SizeTRText + " mm </b>";
      if (frmData.Perilesional) report += "<b>with surrounding " + frmData.PerilesiType + " perilesional edema. </b>";

      if (frmData.MassEffect) {
        let arr1 = [];
        if (frmData.EffacedSulci) arr1.push("effaced sulci");
        if (frmData.EffacedLateralVentricles) arr1.push("effaced lateral ventricle");
        if (frmData.UncalHerniation) arr1.push("uncal herniation");
        report += "<br><br><b>Mass effect is noted in the form of " + arr1.join(", ") + "</b>";
        impression.push("<b>with mass effect as described. </b>");
      }
      if (frmData.MidlineShift) report += "<b> and midline shaft of " + frmData.MidliniftText + " mm, towards left. </b>";
    }

    if (frmData.IntraLeft) {
      if (frmData.Chronicity1 && frmData.ChicityType1 && frmData.RadioType1==="Multiple") {
        report += "<br><br><b>Multiple " + frmData.ChicityType1 + " intraparenchymal hemorrhage </b>";
        impression.push("<br><b>" + frmData.ChicityType1 + " Multiple intraparenchymal hemorrhage </b>");
      } else if (frmData.Chronicity1 && frmData.ChicityType1) {
        report += "<br><br><b>" + frmData.ChicityType1 + " intraparenchymal hemorrhage </b>";
        impression.push("<br><b>" + frmData.ChicityType1 + " intraparenchymal hemorrhage </b>");
      }

      if (frmData.LeftIntraLocation) {
        let arr = [];
        if (frmData.LeftIntraFrontal) arr.push("frontal");
        if (frmData.LeftIntraTemporal) arr.push("temporal");
        if (frmData.LeftIntraParietal) arr.push("parietal");
        if (frmData.LeftIntraOccipital) arr.push("occipital");
        
        if (arr.length > 0) {
          report += "<b>seen in left " + arr.join("-") + " lobes </b>";
          impression.push("<b>in left " + arr.join("-") + " lobes </b>");
        }

        let arrBase = [];
        if (frmData.LeftIntraBasalGanglia) arrBase.push("basal ganglia");
        if (frmData.LeftIntraThalamus) arrBase.push("thalamus");
        if (frmData.LeftIntraCerebellum) arrBase.push("cerebellum");
        if (frmData.LeftIntraMedulla) arrBase.push("medulla");
        if (frmData.LeftIntraMidBrain) arrBase.push("midbrain");
        if (frmData.LeftIntraPons) arrBase.push("pons");

        if (arrBase.length > 0) {
          report += "<b> and " + arrBase.join("-") + " region. </b>";
          impression.push("<b> and " + arrBase.join("-") + " region. </b>");
        }
      }

      if (frmData.Size1) report += "<b>measuring " + frmData.SizeCCText1 + "x" + frmData.SizeAPText1 + "x" + frmData.SizeTRText1 + " mm </b>";
      if (frmData.Perilesional1) report += "<b>with surrounding " + frmData.Perilesi1Type + " perilesional edema. </b>";

      if (frmData.MassEffect1) {
        let arr1 = [];
        if (frmData.EffacedSulci1) arr1.push("effaced sulci");
        if (frmData.EffacedLateralVentricles1) arr1.push("effaced lateral ventricle");
        if (frmData.UncalHerniation1) arr1.push("uncal herniation");
        report += "<br><br><b>Mass effect is noted in the form of " + arr1.join(", ") + ". </b>";
        impression.push("<b>with mass effect as described. </b>");
      }
      if (frmData.MidlineShift1) report += "<b> and midline shaft of " + frmData.MidliftText1 + " mm, towards right. </b>";
    }

    if (frmData.ExtraAxial) {
      if (frmData.SDH) {
        if (frmData.RightSDH) {
          if (frmData.RightLocaitonChronicity) {
            report += "<br><br><b>" + frmData.RightSDHChronicityType + " SDH is seen along the right </b>";
            impression.push("<b>" + frmData.RightSDHChronicityType + " SDH in right </b>");
          } else {
             report += "<br><br><b>SDH is seen along the right </b>";
          }
          if (frmData.RightLocation) {
            let arr = [];
            if (frmData.RightLocationFrontal) arr.push("frontal");
            if (frmData.RightLocationTemporal) arr.push("temporal");
            if (frmData.RightLocaitonParietal) arr.push("parietal");
            if (frmData.RightLocationOccipital) arr.push("occipital");
            if (arr.length > 0) report += "<b>" + arr.join(", ") + " convexity </b>";

            let arrF = [];
            if (frmData.RightLocationFalx) arrF.push("falx");
            if (frmData.RightLocaitonTantorium) arrF.push("tentorium");
            if (arrF.length > 0) report += "<b> and the " + arrF.join(", ") + " cerebri </b>";
          }
          if (frmData.RightMaximumThickness) report += "<b>with maximum thickness of the hematoma, measuring upto " + frmData.RightMaximumText + " mm. </b>";
          if (frmData.RightMassEffect) {
            let arr = [];
            if (frmData.RightMassEffectEffecedSulci) arr.push("effaced adjacent sulci");
            if (frmData.RightMassEffectLateralVentricle) arr.push("effaced right lateral ventricle");
            if (frmData.RightMassEffectUncal) arr.push("uncal herniation");
            report += "<br><br><b>Mass effect is noted in the form of " + arr.join(", ") + "</b>";
          }
          if (frmData.RightMassMidlineShift) report += "<b> and midline shaft of " + frmData.SDHrightMidLineShiftText + " mm towards left.</b>";
        }

        if (frmData.LeftSDH) {
          if (frmData.LeftLocaitonChronicity) {
            report += "<br><br><b>" + frmData.LeftSDHChronicityType + " SDH is seen along the left </b>";
            impression.push("<b>" + frmData.LeftSDHChronicityType + " SDH in left </b>");
          } else {
            report += "<br><br><b>SDH is seen along the left </b>";
          }
          if (frmData.LeftLocation) {
            let arr = [];
            if (frmData.LeftLocationFrontal) arr.push("frontal");
            if (frmData.LeftLocationTemporal) arr.push("temporal");
            if (frmData.LeftLocaitonParietal) arr.push("parietal");
            if (frmData.LeftLocationOccipital) arr.push("occipital");
            if (arr.length > 0) report += "<b>" + arr.join(", ") + " convexity </b>";

            let arrF = [];
            if (frmData.LeftLocationFalx) arrF.push("falx");
            if (frmData.LeftLocaitonTantorium) arrF.push("tentorium");
            if (arrF.length > 0) report += "<b> and the " + arrF.join(", ") + " cerebri </b>";
          }
          if (frmData.LeftMaximumThickness) report += "<b>with maximum thickness of the hematoma, measuring upto " + frmData.LeftMaximumText + " mm. </b>";
          if (frmData.LeftMassEffect) {
            let arr = [];
            if (frmData.LeftMassEffectEffecedSulci) arr.push("effaced adjacent sulci");
            if (frmData.LeftMassEffectLateralVentricle) arr.push("effaced right lateral ventricle");
            if (frmData.LeftMassEffectUncal) arr.push("uncal herniation");
            report += "<br><br><b>Mass effect is noted in the form of " + arr.join(", ") + "</b>";
          }
          if (frmData.LeftMassMidlineShift) report += "<b> and midline shaft of " + frmData.LeftSDHMidLineShiftText + " mm towards right.</b>";
        }
      }

      if (frmData.EDH) {
        if (frmData.RightEDH) {
          if (frmData.EDHRightLocaitonChronicity) {
            report += "<br><br><b>" + frmData.EDHRightLocaitonChronicityType + " EDH is seen along the right </b>";
            impression.push("<b>" + frmData.EDHRightLocaitonChronicityType + " EDH in right </b>");
          } else {
             report += "<br><br><b>EDH is seen along the right </b>";
          }
          if (frmData.EDHRightLocation) {
            let arr = [];
            if (frmData.EDHRightLocationFrontal) arr.push("frontal");
            if (frmData.EDHRightLocationTemporal) arr.push("temporal");
            if (frmData.EDHRightLocaitonParietal) arr.push("parietal");
            if (frmData.EDHRightLocationOccipital) arr.push("occipital");
            if (arr.length > 0) report += "<b>" + arr.join(", ") + " convexity </b>";
          }
          if (frmData.EDHRightMaximumThickness) report += "<b> with maximum thickness of the hematoma, measuring " + frmData.EDHRightMaximumText + " mm. </b>";
          if (frmData.EDHRightMassEffect) {
            let arr = [];
            if (frmData.EDHRightMassEffectEffecedSulci) arr.push("effaced adjacent sulci");
            if (frmData.EDHRightMassEffectLateralVentricle) arr.push("effaced right lateral ventricle");
            if (frmData.EDHRightMassEffectUncal) arr.push("uncal herniation");
            report += "<br><br><b>Mass effect is noted in the form of " + arr.join(", ") + "</b>";
          }
          if (frmData.EDHRightMassMidlineShift) report += "<b> and midline shaft of " + frmData.EDHRightMassMidLineShiftText + "mm towards left.</b>";
        }

        if (frmData.LeftEDH) {
          if (frmData.EDHLeftLocaitonChronicity) {
            report += "<br><br><b>" + frmData.EDHLeftLocaitonChronicityType + " EDH is seen along the left </b>";
            impression.push("<b>" + frmData.EDHLeftLocaitonChronicityType + " EDH in left </b>");
          } else {
             report += "<br><br><b>EDH is seen along the left </b>";
          }
          if (frmData.EDHLeftLocation) {
            let arr = [];
            if (frmData.EDHLeftLocationFrontal) arr.push("frontal");
            if (frmData.EDHLeftLocationTemporal) arr.push("temporal");
            if (frmData.EDHLeftLocaitonParietal) arr.push("parietal");
            if (frmData.EDHLeftLocationOccipital) arr.push("occipital");
            if (arr.length > 0) report += "<b>" + arr.join(", ") + " convexity </b>";
          }
          if (frmData.EDHLeftMaximumThickness) report += "<b> with maximum thickness of the hematoma, measuring " + frmData.EDHLeftMaximumText + " mm. </b>";
          if (frmData.EDHLeftMassEffect) {
            let arr = [];
            if (frmData.EDHLeftMassEffectEffecedSulci) arr.push("effaced adjacent sulci");
            if (frmData.EDHLeftMassEffectLateralVentricle) arr.push("effaced right lateral ventricle");
            if (frmData.EDHLeftMassEffectUncal) arr.push("uncal herniation");
            report += "<br><br><b>Mass effect is noted in the form of " + arr.join(", ") + "</b>";
          }
          if (frmData.EDHLeftMassMidlineShift) report += "<b> and midline shaft of " + frmData.EDHLeftMassMidLineShiftText + " mm towards right.</b>";
        }
      }
    }

    if (frmData.SAH) {
      if (frmData.SAHType) report += "<br><br><b>" + frmData.SAHType + "</b>";
      
      let arrR = [];
      if (frmData.SAHRight) {
        if (frmData.SAHRightFrontal) arrR.push("frontal");
        if (frmData.SAHRightParietal) arrR.push("parietal");
        if (frmData.SAHRightOccipital) arrR.push("occipital");
        if (frmData.SAHRightTemporal) arrR.push("temporal");
        if (frmData.SAHRightFalx) arrR.push("falx");
        if (frmData.SAHRightBasalCisterns) arrR.push("Basal cisterns");
        if (frmData.SAHRightSylvianFissures) arrR.push("sylvian fissures");
        if (frmData.SAHRightSuprasellerCistern) arrR.push("supraseller cistern");
      }

      let arrL = [];
      if (frmData.SAHLeft) {
        if (frmData.SAHLeftFrontal) arrL.push("frontal");
        if (frmData.SAHLeftParietal) arrL.push("parietal");
        if (frmData.SAHLeftOccipital) arrL.push("occipital");
        if (frmData.SAHLeftTemporal) arrL.push("temporal");
        if (frmData.SAHLefttFalx) arrL.push("falx");
        if (frmData.SAHLeftBasalCisterns) arrL.push("Basal cisterns");
        if (frmData.SAHLeftSylvianFissures) arrL.push("sylvian fissures");
        if (frmData.SAHLeftSuprasellerCistern) arrL.push("supraseller cistern");
      }

      if (arrR.length > 0 && arrL.length > 0) {
        report += "<b> subarachnoid hemorrhage seen in right " + arrR.join(", ") + " and left " + arrL.join(", ") + ".</b>";
        impression.push("<b> subarachnoid hemorrhage seen in right " + arrR.join(", ") + " and left " + arrL.join(", ") + ".</b>");
      } else if (arrR.length > 0) {
        report += "<b> subarachnoid hemorrhage seen in right " + arrR.join(", ") + ".</b>";
        impression.push("<b> subarachnoid hemorrhage seen in right " + arrR.join(", ") + ".</b>");
      } else if (arrL.length > 0) {
        report += "<b> subarachnoid hemorrhage seen in left " + arrL.join(", ") + ".</b>";
        impression.push("<b> subarachnoid hemorrhage seen in left " + arrL.join(", ") + ".</b>");
      }
    }

    if (frmData.IVH) {
      let arr1 = [];
      if (frmData.LateralVentriclesLeft) arr1.push("left lateral ventricle");
      if (frmData.LateralVentriclesRight) arr1.push("right lateral ventricle");
      if (frmData.ThirdVentricles) arr1.push("third ventricle");
      if (frmData.FourthVentricles) arr1.push("fourth ventricle");
      report += "<br><br><b>IVH seen in " + arr1.join(", ") + ".</b>";
      
      if (frmData.ObstructiveHydrocephalus) {
        report += "<br><br><b> Obstructive hydrocephalus seen. </b>";
      } else {
        report += "<br><br><b> No obstructive hydrocephalus seen. </b>";
      }
      if (frmData.EvansIndex) report += "<br><br><b> Evans index is " + frmData.EvansIndex + ".</b>";
    }

    report += "<br><br>Cerebral parenchyma appears normal.<br><br>Basal ganglia and thalamus are normal.<br><br>Cerebellum is normal.<br><br>Brainstem is normal.<p>The bones under view are normal. </p>";
  }

  if (frmData.ChronicIschemic) {
    report += "<p><b>• Ill-defined hypodensities seen in bilateral fronto-parietal white matter.</b><br><br>• No evidence of contusion, edema or intracranial hemorrhage is visualized.<br><br>• No evidence of fracture.<br><br>• The cerebellum and brainstem appear normal.<br><br>• Cerebello pontine angles and internal auditory meatus appear normal.<br><br>• The sella and parasellar regions are normal.<br><br>• The basal ganglia, thalami and capsular tracts appear normal.<br><br>• The bones of skull and pericranial soft tissue appear normal.<br><br>• Visualized paranasal sinuses appear normal<b></p>";
    impression.push("<b> Chronic small vessel ischemic changes seen in bilateral fronto-parietal white matter. </b>");
  }

  if (frmData.Infarct) {
    if (frmData.Location) {
      if (frmData.InfractRight) {
        let arr = [];
        if (frmData.Frontal) arr.push("frontal");
        if (frmData.Parietal) arr.push("parietal");
        if (frmData.Temporal) arr.push("temporal");
        if (frmData.Occipital) arr.push("occipital");
        if (frmData.BasalGanglia) arr.push("basal ganglia");
        if (frmData.Thalamus) arr.push("thalamus");
        if (frmData.CoronaRadiate) arr.push("corona radiate");
        if (frmData.CentrumSemiovale) arr.push("centrum semiovale");
        if (frmData.Cerebellum) arr.push("cerebellum");
        if (frmData.Pons) arr.push("pons");
        if (frmData.Medulla) arr.push("medulla");
        if (frmData.Midbrain) arr.push("midbrain");
        report += "<p><b>" + text.LocationTypetext.replace("{2}", arr.join("-")) + "</b></p>";
        impression.push("<b>" + text.LocationTypetext1.replace("{2}", arr.join("-")) + (frmData.TypeofInfarct ? "- likely " + frmData.InfarctTypes + " infarct." : "") + "</b>");
      }
      if (frmData.InfractLeft) {
        let arr = [];
        if (frmData.Frontal1) arr.push("frontal");
        if (frmData.Parietal1) arr.push("parietal");
        if (frmData.Temporal1) arr.push("temporal");
        if (frmData.Occipital1) arr.push("occipital");
        if (frmData.BasalGanglia1) arr.push("basal ganglia");
        if (frmData.Thalamus1) arr.push("thalamus");
        if (frmData.CoronaRadiate1) arr.push("corona radiate");
        if (frmData.CentrumSemiovale1) arr.push("centrum semiovale");
        if (frmData.Cerebellum1) arr.push("cerebellum");
        if (frmData.Pons1) arr.push("pons");
        if (frmData.Medulla1) arr.push("medulla");
        if (frmData.Midbrain1) arr.push("midbrain");
        report += "<p><b>" + text.LocationTypetextleft.replace("{2}", arr.join("-")) + "</b></p>";
        impression.push("<b>" + text.LocationTypetextleft1.replace("{2}", arr.join("-")) + (frmData.TypeofInfarct ? "- likely " + frmData.InfarctTypes + " infarct." : "") + "</b>");
      }
    }
    
    if (frmData.HemorrhagicTransFormation) {
      if (frmData.HeTransformationCC || frmData.HeTransformationAP || frmData.HeTransformationTR) {
        report += "<p><b>Hemorrhagic transformation seen measuring " + frmData.HeTransformationCC + " x " + frmData.HeTransformationAP + " x " + frmData.HeTransformationTR + "mm.</b></p>";
      }
    }

    if (frmData.Location || frmData.HemorrhagicTransFormation) {
      report += "<p>No evidence of fracture.<br><br>The gray white differentiation is maintained.<br><br>Cerebello pontine angles and internal auditory meatus appear normal.<br><br>Ventricular system and sulci are normal for the age.<br><br>The sella and parasellar regions are normal.<br><br>The bones of skull and pericranial soft tissue appear normal.<br><br>Visualized paranasal sinuses appear normal.</p>";
    }
  }

  report += `<div class="page-break ck-widget ck-widget_selected" contenteditable="false" draggable="true"></div>`;

  report += `
    <p><strong><u>IMPRESSION:</u></strong></p>
    <p>${impression.length > 0 ? impression.join("<br>") : "<strong>• No significant abnormality in the brain.</strong>"}</p>
  `;

  if (currentUser) {
    report += `
      <p>
        <br>
        <img src="${currentUser.signature}" height="75" />
        <br>${currentUser.full_name}<br>${currentUser.designation}
      </p>
    `;
  }

  return report;
}